<dx-popup
  [width]="600"
  [height]="'auto'"
  [title]="dialogTitle"
  [showTitle]="true"
  (onHiding)="closeDialog()"
  [(visible)]="displayDialog"
  [resizeEnabled]="true"
  [showCloseButton]="false"
>
  <form (ngSubmit)="save()" [formGroup]="form">

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Site <span class="danger-color">*</span> </div>
      <div class="col-md-8">
        <dx-lookup
          [items]="getSitesLocaux()"
          formControlName="site"
          placeholder="Sélectionner un site"
          valueExpr="id"
          displayExpr="libelle"
          searchExpr="libelle"
        >
        </dx-lookup>
      </div>
    </div>

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Libellé <span class="danger-color">*</span> </div>
      <div class="col-md-8">
        <div class="input-group-sm">
          <dx-text-box placeholder="Nom du plan de production" formControlName="libelle"></dx-text-box>
        </div>
      </div>
    </div>

    <div class="p-2 d-flex justify-content-end">
      <yo-button type="submit" tooltip="Enregistrer" class="mg-r-15" iconClass="fas fa-save" [theme]="ButtonThemeEnum.SAVE"></yo-button>
      <yo-button type="button" tooltip="Fermer" iconClass="fas fa-times" [theme]="ButtonThemeEnum.CANCEL" (onClick)="closeDialog()"></yo-button>
    </div>
  </form>

</dx-popup>
